import type { Alarm, IncidentsPayload } from '@cobliteam/common-types';
import type { LoadAlarmsFailed, LoadAlarmsRequest, LoadAlarmsSucceeded } from './actions';
import { ActionTypes } from './actionTypes';

export const loadAlarmsRequest = (alarmsPayload: IncidentsPayload): LoadAlarmsRequest => ({
  type: ActionTypes.LOAD_ALERTS_REQUEST,
  payload: {
    alarmsPayload,
  },
});

export const loadAlarmsSucceeded = (alarms: Alarm[]): LoadAlarmsSucceeded => ({
  type: ActionTypes.LOAD_ALERTS_SUCCEEDED,
  payload: alarms,
});

export const loadAlarmsFailed = (): LoadAlarmsFailed => ({
  type: ActionTypes.LOAD_ALERTS_FAILED,
});
